import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { NgModule } from "@angular/core";

import { DatepickerModule } from "src/app/shared/components/datepicker/datepicker.module";
import { DatumModule } from "src/app/shared/directives/datum";
import { LayoutsModule } from "src/app/shared/components/layouts/layouts.module";
import { MapPipeModule } from "src/app/shared/pipes/map";
import { OptionModule } from "src/app/shared/directives/option";
import { SharedModule } from "src/app/shared/shared.module";
import { StripeModule } from "src/app/shared/modules/stripe/stripe.module";

import { AccountSetupCompleteComponent } from "./complete/account-setup-complete.component";
import { AccountSetupFailedComponent } from "./failed/account-setup-failed.component";
import { AccountSetupPage } from "./account-setup.page";
import { AccountSetupPageRoutingModule } from "./account-setup-routing.module";
import { ChooseAccountLocationComponent } from "./choose-location/choose-account-location.component";
import { ConfirmAccountLinkingComponent } from "./confirm/confirm-account-linking.component";
import { EnterAccountDetailsComponent } from "./enter-details/enter-account-details.component";
import { LookupAccountCreditCardComponent } from "./lookup-credit-card/lookup-credit-card.component";
import { Last4lookupComponent } from "./last4lookup/last4lookup.component";
import { LocateMembershipComponent } from "./locate-membership/locate-membership.component";
import { MatTabsModule } from "@angular/material/tabs";
import { MyqqButtonModule } from "src/app/shared/components/button/button.module";
import { EvoxImageModule } from "src/app/shared/modules/evox/evox.module";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { MatCheckboxModule } from "@angular/material/checkbox";

@NgModule({
  imports: [
    AccountSetupPageRoutingModule,
    CommonModule,
    DatepickerModule,
    DatumModule,
    EvoxImageModule,
    FormsModule,
    LayoutsModule,
    MapPipeModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MyqqButtonModule,
    MatTabsModule,
    MyqqButtonModule,
    OptionModule,
    ReactiveFormsModule,
    SharedModule,
    StripeModule,
    NgxMaskDirective,
  ],
  declarations: [
    AccountSetupCompleteComponent,
    AccountSetupFailedComponent,
    AccountSetupPage,
    ChooseAccountLocationComponent,
    ConfirmAccountLinkingComponent,
    EnterAccountDetailsComponent,
    LookupAccountCreditCardComponent,
    Last4lookupComponent,
    LocateMembershipComponent,
  ],
  providers: [provideNgxMask()],
})
export class AccountSetupPageModule {}
